import FindPeople from "./findPeople";
import { useNavigate } from "react-router-dom";

export default function findPeopleScreen() {
  const navigate = useNavigate();

  return (
    <FindPeople
      onBack={() => navigate(-1)}
      onContinue={() => navigate("/viewPost")}
    />
  );
}
